import ThemedComponent from '../../hoc/ThemedComponent';

import { default as TransferRequestByIPPageDefault } from './TransferRequestByIPPage';
import { default as TransferRequestByIPPage3 } from '../../themes/3/pages/transferRequestByIP/TransferRequestByIPPage';

const TransferRequestByIPPages = {
    default: TransferRequestByIPPageDefault,
    // 3: TransferRequestByIPPage3,
};

export const TransferRequestByIPPage = ThemedComponent(TransferRequestByIPPages);
